import { DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST, GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_AVAILABLE_TAKA_NO, DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE,
  GET_DELIVERY_CHALLAN_RETURN_AVAILABLE_TRANSACTIONS } from '../types';

const initialState = {
  availableReturnTransactions: [],
  availableReturnTakaNos: [],
  loading: false,
  error: null,
};

const deliveryChallanReturnAvailableTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_RETURN_AVAILABLE_TRANSACTIONS: {
      return {
        ...state,
        availableReturnTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_AVAILABLE_TAKA_NO: {
      return {
        ...state,
        availableReturnTakaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default deliveryChallanReturnAvailableTransactionReducer;
